/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Track } from './Track';
import {
    TrackFromJSON,
    TrackFromJSONTyped,
    TrackToJSON,
} from './Track';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface Tracks
 */
export interface Tracks {
    /**
     * 
     * @type {number}
     * @memberof Tracks
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof Tracks
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof Tracks
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof Tracks
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof Tracks
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof Tracks
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof Tracks
     */
    version: VersionMetadata;
    /**
     * 
     * @type {Array<Track>}
     * @memberof Tracks
     */
    data?: Array<Track>;
}

/**
 * Check if a given object implements the Tracks interface.
 */
export function instanceOfTracks(value: object): value is Tracks {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function TracksFromJSON(json: any): Tracks {
    return TracksFromJSONTyped(json, false);
}

export function TracksFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tracks {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TrackFromJSON)),
    };
}

export function TracksToJSON(value?: Tracks | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TrackToJSON)),
    };
}

